import { useTranslation } from 'react-i18next';
import Loading from 'Components/Atoms/Loading/Loading';
import useContactsImports from 'Hooks/useContactsImports';
import ContactsImportsHistoryItem from './ContactsImportsHistoryItem';

export default function ContactsImportsHistoryDrawer() {
    const { imports, isLoading } = useContactsImports();
    const { t } = useTranslation('contacts');

    return (
        <div className="py-4">
            {isLoading && <Loading />}

            {!isLoading && imports.length === 0 && (
                <div className="py-8 text-center text-sm text-gray-500">{t('imports-history-empty')}</div>
            )}

            {imports.map((contactsImport) => (
                <ContactsImportsHistoryItem key={contactsImport.id} contactsImport={contactsImport} />
            ))}
        </div>
    );
}
